import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TradeManagementSystem.css';
import { downloadResume } from '../utils/resumeDownload';

const TradeManagementSystem = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleResumeDownload = downloadResume;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleImageClick = (imageSrc, imageAlt) => {
    setSelectedImage({ src: imageSrc, alt: imageAlt });
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="trade-management-system">
      {/* Header with Background */}
      <header className="header">
        <div className="header-content">
          <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>Subs.</div>
          <nav className="navigation desktop-nav">
            <a href="/about">About</a>
            <a href="/#works">Works</a>
            <a href="/#resume" onClick={handleResumeDownload}>Resume</a>
            <a href="/contact">Contact</a>
          </nav>
          
          {/* Mobile menu button */}
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        
        {/* Mobile Navigation - Offset Canvas */}
        <div className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>
        <div className={`mobile-nav-canvas ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="mobile-nav-header">
            <div className="logo mobile-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>Subs.</div>
            <button className="close-menu-btn" onClick={closeMobileMenu} aria-label="Close menu">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <nav className="mobile-nav">
            <a href="/about" onClick={closeMobileMenu}>About</a>
            <a href="/#works" onClick={closeMobileMenu}>Works</a>
            <a href="/#resume" onClick={(e) => { handleResumeDownload(); closeMobileMenu(); }}>Resume</a>
            <a href="/contact" onClick={closeMobileMenu}>Contact</a>
          </nav>
        </div>
      </header>

      {/* Header Section */}
      <div className="header-section">
        <h1 className="main-title">Trade Management System.</h1>
        <div className="project-details">
          <div className="project-details-row">
            <div className="detail-item">
              <span className="detail-label">Role</span>
              <div className="detail-separator"></div>
              <span className="detail-value">Product Designer</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Timeline</span>
              <div className="detail-separator"></div>
              <span className="detail-value">24 months</span>
            </div>
          </div>
          <div className="detail-item">
            <span className="detail-label">Tools</span>
            <div className="detail-separator"></div>
            <span className="detail-value">Figma, FigJam</span>
          </div>
        </div>
      </div>

      {/* Image Section - Placeholder for your image */}
      <div className="image-section">
        <div className="image-container">
          
          <img 
            src="/placeholder-image.png" 
            alt="Trade Management System UI" 
            className="system-image"
            onClick={() => handleImageClick("/placeholder-image.png", "Trade Management System UI")}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="image-placeholder" style={{ display: 'none' }}>
            <svg className="placeholder-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p>Image placeholder - Update the src path in TradeManagementSystem.js</p>
          </div>
        </div>
      </div>

      {/* Project Information Section */}
      <div className="project-info-section">
        <div className="project-info-container">
          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Project Overview</h3>
            </div>
            <div className="section-content">
              <p className="section-description">
                This software streamlines the buying and selling of financial assets. It manages everything from order placement to trade completion, ensuring compliance with regulations, risk management, and performance tracking.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Identifying Problem</h3>
            </div>
            <div className="section-content">
              <p className="section-description">
                The government's Trade Management System (TMS) was outdated and nearing obsolescence. Its outdated design and features could not keep pace with the changing needs of brokers, resulting in inefficiencies and dissatisfaction.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Research & Analysis</h3>
            </div>
            <div className="section-content">
              <p className="section-description">
                The government's Trade Management System (TMS) was outdated and nearing obsolescence. Its outdated design and features could not keep pace with the changing needs of brokers, resulting in inefficiencies and dissatisfaction.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">STAR Analysis</h3>
            </div>
            <div className="section-content">
              <div className="star-subsection">
                <h4 className="star-subheading">Situation</h4>
                <p className="star-description">
                  The stock trading market in the region operates only from 11:00 AM to 3:00 PM, leading to heavy congestion on the competitor's platform, which serves 2.5 million + users. The competitor's software, launched in 2018, had never been updated, resulting in a poor user experience, slow trade execution, and lack of critical features like portfolio management, technical analysis, and device responsiveness.
                </p>
              </div>

              <div className="star-subsection">
                <h4 className="star-subheading">Task</h4>
                <p className="star-description">
                  The goal was to redesign the platform to:
                </p>
                <ul className="star-list">
                  <li>Simplify complex sections and create a seamless user experience.</li>
                  <li>Enable traders to make quick decisions and execute trades instantly.</li>
                  <li>Introduce missing features like portfolio details, technical analysis, and device responsiveness.</li>
                  <li>Ensure the platform was intuitive and accessible for a broad audience (ages 16 to 55+).</li>
                </ul>
              </div>

              <div className="star-subsection">
                <h4 className="star-subheading">Action</h4>
                <div className="star-description">
                  <div className="action-item">
                    <h5 className="action-subtitle">1. User Research and Segmentation:</h5>
                    <ul className="star-list">
                      <li>Identified key user age groups (mid-twenties to late fifties) and their pain points.</li>
                      <li>Conducted usability testing on the competitor's platform to understand user frustrations.</li>
                    </ul>
                  </div>

                  <div className="action-item">
                    <h5 className="action-subtitle">2. Design Strategy:</h5>
                    <ul className="star-list">
                      <li>Avoided drastic design changes to prevent user deviation and potential loss to competitors.</li>
                      <li>Refined the interface to maintain familiarity while improving usability.</li>
                      <li>Prioritized essential features and removed non-essential metrics to reduce cognitive load.</li>
                    </ul>
                  </div>

                  <div className="action-item">
                    <h5 className="action-subtitle">3. Key Features Added:</h5>
                    <ul className="star-list">
                      <li><strong>Portfolio Details:</strong> Provided a comprehensive overview of holdings, including real-time profit/loss, asset allocation, and historical performance.</li>
                      <li><strong>Technical Analysis:</strong> Integrated advanced charting tools, indicators, and drawing tools for traders to analyze stocks effectively.</li>
                      <li><strong>Device Responsiveness:</strong> Ensured the platform worked seamlessly across devices (web, desktop, tablet, mobile) with a consistent experience.</li>
                      <li><strong>Intuitive Design and Flow:</strong> Simplified navigation, enabling users to execute trades in fewer clicks.</li>
                    </ul>
                  </div>

                  <div className="action-item">
                    <h5 className="action-subtitle">4. Iterative Testing:</h5>
                    <ul className="star-list">
                      <li>Conducted multiple UX testing sessions with target users (traders).</li>
                      <li>Gathered feedback and iterated on the design to optimize usability and performance.</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="star-subsection">
                <h4 className="star-subheading">Result</h4>
                <div className="star-description">
                  <div className="result-item">
                    <h5 className="result-subtitle">1. User Research and Segmentation:</h5>
                    <ul className="star-list">
                      <li>20% of users were able to trade faster and achieve their goals more efficiently.</li>
                      <li>Users reported reduced distractions from non-essential metrics, allowing them to focus on trading.</li>
                    </ul>
                  </div>

                  <div className="result-item">
                    <h5 className="result-subtitle">2. Competitive Advantage:</h5>
                    <ul className="star-list">
                      <li>Introduced missing features (portfolio details, technical analysis, device responsiveness) that were absent in the competitor's platform.</li>
                      <li>Created a modern, intuitive design that retained familiarity while enhancing usability.</li>
                    </ul>
                  </div>

                  <div className="result-item">
                    <h5 className="result-subtitle">3. Scalability and Accessibility:</h5>
                    <ul className="star-list">
                      <li>The platform accommodated a broad audience (ages 16 to 55+) and adhered to accessibility standards.</li>
                      <li>Designed to handle high traffic during peak trading hours (11:00 AM to 3:00 PM).</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Solution</h3>
            </div>
            <div className="section-content">
              <p className="section-description">
                We created a custom TMS for each broker, prioritizing user experience and flexibility. By focusing on straightforward information layout, contemporary interaction styles, and accessibility, we equipped brokers with tools that fit their specific needs, boosting both functionality and user satisfaction.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Dashboard</h3>
            </div>
            <div className="section-content">
              <div className="dashboard-content">
                <div className="dashboard-description">
                  <p className="section-description">
                    This dashboard offers a concise overview of trading activities, fund and collateral summaries, market insights, and user account details for efficient trade management.
                  </p>
                </div>
                <div className="dashboard-image-placeholder">
                  <img 
                    src="/dashboard-placeholder.png" 
                    alt="TMS Dashboard Interface" 
                    className="dashboard-image"
                    onClick={() => handleImageClick("/dashboard-placeholder.png", "TMS Dashboard Interface")}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  
                </div>
              </div>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Order Management</h3>
            </div>
            <div className="section-content">
              <div className="dashboard-content">
                <div className="dashboard-description">
                  <p className="section-description">
                  This page allows users to manage trades effectively, including placing buy/sell orders, 
                  viewing top buy/sell stats, and monitoring collateral details. It also displays an 
                  interactive order book to track order statuses and execution.
                  </p>
                </div>
                <div className="dashboard-image-placeholder">
                  <img 
                    src="/orderManagement.png" 
                    alt="TMS Order Management Interface" 
                    className="dashboard-image"
                    onClick={() => handleImageClick("/orderManagement.png", "TMS Order Management Interface")}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  
                </div>
              </div>
            </div>
          </div>

          {/* live market */}
          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Live Market</h3>
            </div>
            <div className="section-content">
              <div className="dashboard-content">
                <div className="dashboard-description">
                  <p className="section-description">
                  This page allows users to manage trades effectively, 
                  including placing buy/sell orders, viewing top buy/sell stats, 
                  and monitoring collateral details. It also displays an 
                  interactive order book to track order statuses and execution.
                  </p>
                </div>
                <div className="dashboard-image-placeholder">
                  <img 
                    src="/livemarket.png" 
                    alt="TMS Live Market Interface" 
                    className="dashboard-image"
                    onClick={() => handleImageClick("/livemarket.png", "TMS Live Market Interface")}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                 
                </div>
              </div>
            </div>
          </div>

          {/* Personalised Account Statement */}
          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Personalised <br/>Account Statement</h3>
            </div>
            <div className="section-content">
              <div className="dashboard-content">
                <div className="dashboard-description">
                  <p className="section-description">
                  This page allows users to manage trades effectively, 
                  including placing buy/sell orders, viewing top buy/sell stats, 
                  and monitoring collateral details. It also displays an 
                  interactive order book to track order statuses and execution.
                  </p>
                </div>
                <div className="dashboard-image-placeholder">
                  <img 
                    src="/personalisedaccountstatement.png" 
                    alt="TMS Personalised Account Statement Interface" 
                    className="dashboard-image"
                    onClick={() => handleImageClick("/personalisedaccountstatement.png", "TMS Personalised Account Statement Interface")}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                 
                </div>
              </div>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Key Takeaways</h3>
            </div>
            <div className="section-content">
              <div className="key-takeaways-content">
                <div className="takeaway-item">
                  <h4 className="takeaway-subheader">User-Centric Design</h4>
                  <p className="takeaway-description">
                    By understanding user pain points and avoiding drastic changes, the design maintained user loyalty while improving the experience.
                  </p>
                </div>
                
                <div className="takeaway-separator"></div>
                
                <div className="takeaway-item">
                  <h4 className="takeaway-subheader">Feature Innovation</h4>
                  <p className="takeaway-description">
                    Adding portfolio details, technical analysis, and device responsiveness gave the platform a competitive edge.
                  </p>
                </div>
                
                <div className="takeaway-separator"></div>
                
                <div className="takeaway-item">
                  <h4 className="takeaway-subheader">Interactive Testing</h4>
                  <p className="takeaway-description">
                    Continuous feedback and improvements ensured the final product met user needs effectively.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Main UI Section */}
     
      {/* Back Button */}
      <div className="back-section">
        <button className="back-btn" onClick={() => window.history.back()}>
          <svg className="back-arrow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span>Back to Portfolio</span>
        </button>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal-overlay" onClick={closeModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal-close" onClick={closeModal}>
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt} 
              className="image-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TradeManagementSystem;
